import React, { useEffect, useState } from "react";
import { useParams, Outlet } from "react-router-dom";
import { api, getActiveSubdomain } from "@/lib/api";

function hexToRgb(hex) {
  const h = hex.replace('#', '');
  if (h.length === 3) return `${parseInt(h[0]+h[0],16)} ${parseInt(h[1]+h[1],16)} ${parseInt(h[2]+h[2],16)}`;
  if (h.length === 6) return `${parseInt(h.slice(0,2),16)} ${parseInt(h.slice(2,4),16)} ${parseInt(h.slice(4,6),16)}`;
  return null;
}

// Simple shade down for hovers
function darkenHex(hex, amount = 20) {
  let r = parseInt(hex.slice(1,3), 16) - amount;
  let g = parseInt(hex.slice(3,5), 16) - amount;
  let b = parseInt(hex.slice(5,7), 16) - amount;
  r = Math.max(0, r).toString(16).padStart(2, '0');
  g = Math.max(0, g).toString(16).padStart(2, '0');
  b = Math.max(0, b).toString(16).padStart(2, '0');
  return `#${r}${g}${b}`;
}

export default function SiteWrapper() {
  const { subdomain: paramSubdomain } = useParams();
  const subdomain = getActiveSubdomain() || paramSubdomain;
  const [theme, setTheme] = useState({});
  const [site, setSite] = useState(null);

  useEffect(() => {
    if (!subdomain) return;
    api.get(`/site/${subdomain}`)
      .then(r => {
        const s = r.data;
        setSite(s);
        const p = s.panel_color_primary || s.color_primary || "#185FA5";
        const a = s.panel_color_accent || s.color_accent || "#1D9E75";
        const n = s.panel_color_nav || s.color_nav || "#0C447C";
        
        setTheme({
          '--brand-primary': p,
          '--brand-primary-hover': darkenHex(p),
          '--brand-accent': a,
          '--brand-accent-hover': darkenHex(a),
          '--brand-nav': n,
          '--brand-nav-hover': darkenHex(n),
        });
      })
      .catch(() => {});
  }, [subdomain]);

  return (
    <div style={theme} className="contents">
      <Outlet context={site} />
    </div>
  );
}
